export const fetchRelatedArticles = (resp: any) => ({
  type: 'FETCH_RELATED_ARTICLES',
  payload: resp,
});

export default {
  fetchRelatedArticles,
};
